
import { defineComponent, ref } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code7 } from "./data";

export default defineComponent({
  name: "autosize-textarea",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      textarea1: ref(""),
      textarea2: ref(""),
      code7
    };
  }
});
